import { useTranslation } from 'react-i18next';
import { STATUS_CONFIG } from './StatusBadge';
import AppLayout from '../../components/AppLayout';
import { canCreateClaim } from '../../utils/rbac';
import useClaimFunctions from './useClaimFunctions';
import Header from './Header';
import Filter from './Filter';
import Table from './Table';
import Pagination from './Pagination';

// ─── Static fallback data (commented out — no longer used for initialization) ───
// const CLAIMS_FALLBACK = [ /* ... removed for brevity ... */ ];

const ClaimsScreen = () => {
  const { t } = useTranslation();
  const {
    filtered,
    userRole,
    assignees,
    updateCount,
    loading,
    page,
    setPage,
    dateToFilter,
    setDateToFilter,
    dateFromFilter,
    setDateFromFilter,
    assigneeFilter,
    setAssigneeFilter,
    statusFilter,
    setStatusFilter,
    searchQuery,
    setSearchQuery,
    total,
    history,
    claims,
    fetchClaims,
    PAGE_SIZE,
    setPageSize,
    S,
  } = useClaimFunctions();

  if (loading) {
    return (
      <AppLayout>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 60 }}>
          <div style={{ width: 36, height: 36, border: '3px solid #e2e8f0', borderTopColor: '#7c3aed', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* Header */}
        <Header canCreateClaim={canCreateClaim} history={history} userRole={userRole} claims={claims} S={S} />

        {/* Live update banner */}
        {updateCount > 0 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 32px',
              background: '#eff6ff',
              borderBottom: '1px solid #bfdbfe',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#3b82f6', animation: 'dashPulse 1.5s infinite' }} />
              <span style={{ fontSize: 13, color: '#1d4ed8', fontWeight: 500 }}>
                {t('screens.claimsScreen.updatesBanner', { count: updateCount })}
              </span>
            </div>
            <button
              onClick={fetchClaims}
              style={{ fontSize: 12, fontWeight: 600, color: '#1d4ed8', background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
            >
              {t('screens.claimsScreen.refresh')}
            </button>
          </div>
        )}

        {/* Filter bar */}
        <Filter
          searchQuery={searchQuery}
          assigneeFilter={assigneeFilter}
          setSearchQuery={setSearchQuery}
          setStatusFilter={setStatusFilter}
          STATUS_CONFIG={STATUS_CONFIG}
          statusFilter={statusFilter}
          S={S}
          setAssigneeFilter={setAssigneeFilter}
          assignees={assignees}
          dateFromFilter={dateFromFilter}
          setDateFromFilter={setDateFromFilter}
          dateToFilter={dateToFilter}
          setDateToFilter={setDateToFilter}
        />

        {/* Table */}
        <Table filtered={filtered} history={history} S={S} canCreateClaim={canCreateClaim} userRole={userRole} />

        {/* Pagination */}
        <Pagination PAGE_SIZE={PAGE_SIZE} setPage={setPage} S={S} page={page} filtered={filtered} total={total} setPageSize={setPageSize} />
      </div>
    </AppLayout>
  );
};

export default ClaimsScreen;
